<template>
	<div v-if="data" class="invite_wrap">
		<div class="basic_wrap">
			<div class="red_top_bg">
				<div class="back_left" @click="$router.back()"></div>
				<div class="big_tit">{{$t('ihome.tron')}}</div>
				<div class="top_right" @click="$router.push('/moneybag')">
					<van-icon name="bars" size="25"/>
				</div>
			</div>
			<div class="top_header">
				<div class="user_detail">
					<div class="user_header">
						<img src="../images/shop/head.png" alt="">
					</div>
					<div class="user_name" v-if="vip">
						<div class="user_all" style="font-size: 14px;font-weight: 600;line-height: 30px;display: flex;align-items: center;">
							<p style="margin-left: 1em;margin-right: 5px;">{{user.name}}</p>
							<van-icon :name="vip.img"  size="25" />
						</div>
						<div class="user_all" v-if="user">
							<p style="font-size: 12px;line-height: 23px;margin-left: 1em;font-weight: bold;">
								{{$t('d.creditscore')}}: 
								<van-progress stroke-width="6" color="#f1bb0e" :percentage="user.integral" style="display: inline-block;width: 100px;"/>
							</p>
						</div>
					</div>
				</div>
				
				<div class="con">
					<div class="vip-box" v-if="vip">
					    <div class="VipLevel flex-b-c">
					        <div class="left flex-b-c">
								<van-icon :name="vip.img" size="25" />
					            <span class="level">{{vip.name}}</span>
					        </div>
					        <div class="right flex-b-c">
					            <span class="clickToEnte">{{$t('e.CurrentVIPLevel')}}</span>
					            <!-- <van-icon name="arrow" size="14" /> -->
					        </div>
					    </div>
					</div>
					
					
				</div>
			</div>
			
			<div  class="vipContent">
			    <div  style="filter: blur(4px);">
			        <img  src="../images/shop/vipbg.png" class="BG">
			    </div>
			    <div  class="flex-b-s" style="overflow-x: scroll; margin: 0px 16px; height: 100%;">
			        <van-swipe class="my-swipe" indicator-color="white" v-if="vips" :initial-swipe="vip.no-1">
			          <van-swipe-item v-for="(it,i) in vips">
						  <div class="vipss" style="margin-right: 0px;">
						      <div style="height: 100%; width: 100%;">
						          <div class="vip">
						              <div class="Viplevel flex-b-s">
						                  <div class="left flex-s-c">
						                      <van-icon :name="it.img" size="36" />
						                      <div class="vipText">
						                          <div class="fwBlod"></div>
						                          <div class="fwBlod">{{it.name}}</div>
						                      </div>
						                  </div>
						                  <div class="right">
												<div v-if="vip && vip.no<it.no" class="haveOpened" @click="$router.push('/kefu')" >
													<!-- {{$t('e.ActivateNow')}} -->
													{{utils_moneyMark()}} {{it.price}}
												</div>
												<div v-else class="haveOpened">{{$t('e.AlreadyActivated')}}</div>
						                     
						                  </div>
						              </div>
									  <van-progress class="progressBar flex-s-c" stroke-width="6" color="#f1bb0e" percentage="100" style="display: inline-block; width: 80%;"/>
						              <div class="exp flex-b-c"><span>{{it.value}}{{$t('e.usdc')}}</span><span>{{vips[i+1]?vips[i+1].value:9999999}}{{$t('e.usdc')}}</span>
						              </div>
						              <div class="CurrentVIPlevel flex-c-c fwBlod"
						                   style="background: rgb(0, 0, 0); color: rgb(255, 255, 255);">
										   {{$t('e.CurrentVIPLevel')}}
						              </div>
						          </div>
						          <div class="Tips"><p>{{$t('e.viptip')}}</p>
						              <p>● {{$t('e.viptip1')}}: {{it.cnum}} / {{$t('investdetail.days')}}</p>
						              <p>● {{$t('e.viptip2')}}: {{utils_moneyMark()}} {{it.maxn}}</p>
						              <p>● {{$t('e.viptip3')}}: {{it.onum}} / {{$t('investdetail.days')}}</p>
						              <p>● {{$t('e.viptip4')}}: {{it.rate}} %</p>
						             <!-- <p>●There are {{it.onum}} missions per group</p>
						              <p>●{{it.name}} can submit up to 120 tasks per day.</p> -->
								  </div>
						      </div>
						      <div class="dredge">
						          <button v-if="vip && vip.no<it.no" @click="$router.push('/kefu')" type="button" class="van-button van-button--default van-button--large Btn">
						              <div class="van-button__content"><span class="van-button__text">{{$t('e.ActivateNow')}}</span></div>
						          </button>
								  <button v-else  type="button" class="van-button van-button--default van-button--large Btn">
								      <div class="van-button__content"><span class="van-button__text">{{$t('e.AlreadyActivated')}}</span></div>
								  </button>
						      </div>
						  </div>
					  </van-swipe-item>
			        <!--  <van-swipe-item>2</van-swipe-item>
			          <van-swipe-item>3</van-swipe-item>
			          <van-swipe-item>4</van-swipe-item> -->
			        </van-swipe>
			    </div>
			</div>
			
			
			
			<!-- <div class="table-wrap" v-if="vips">
				<template v-for="(it,i) in vips">
					<div class="vip-item">
						<div class="viphead">
							<div class="vip-info">
								<img :src="it.img" loading="lazy" alt="" class="vip-img">
								<div style="margin: 10px">
									<div class="vip-name">{{it.name}}</div>
									<div class="vip-desc">
										<span >$ </span>
										<span class="text-bold text-df" style="color: #ff5001;">{{it.value}}</span>
									</div>
								</div>
							</div>
							<div class="action-box">
							   <van-icon v-if="vip && vip.no<it.no" name="lock" size="23" color="#f1bb0e"/>
							   <van-icon v-else name="checked" size="23" color="#fa9832"/>
							</div>
							<div class="absoulte-level">VIP{{i}}</div>
						</div>
						<p>
							Per Task Commission {{it.rate}} %<br>
							{{it.onum}} Task Completed/Group<br>
							Able to withdraw 100 times, 0% Charges
						</p>
					</div>
					
				</template>
			</div> -->
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue';
	import Vue from 'vue';
	import {
		Progress,
		Swipe, SwipeItem,
		Empty,
		Icon
	} from 'vant';
	import Clipboard from "v-clipboard";
	Vue
	.use(Swipe)
	.use(SwipeItem)
	.use(Progress)
	.use(Empty)
	.use(Clipboard)
	.use(Icon);
	export default {
		name: "vip",
		data() {
			return {
				data:null,
				user:null,
				vip:null,
				vips:null
			};
		},
		components: {
			bsHeader
		},
		created() {
			this.$parent.footer('item');
		},
		mounted() {
			
			this.start();
		},
		methods: {
			start() {
				Fetch("/user/basicinfo").then((r) => {
					this.data = r.data;
					this.vips = r.data.vips;
					this.vip = r.data.vip;
					this.user = r.data.user;
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		height: 44px;
		// background: url(../images/user/tg_bg.png) no-repeat center center;
		background-size: 100% 100%;
		position: relative;
		border-radius: 0;
		.big_tit {
			position: absolute;
		}
		.back_right{
			position: absolute;
			top: 3px;
			right: 3px;
		}
		.introduce {
		    height: 25px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 18px;
		    line-height: 25px;
		    color: #FFFFFF;
		    margin-top: 20px;
		
		    .line {
		        width: 36px;
		        height: 10px;
		    }
		
		    .tit {
		        margin: 0 12px;
		        font-weight: bold;
		    }
		
		    .left_line {
		        background: url(../images/user/left_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		
		    .right_line {
		        background: url(../images/user/right_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		}
		.award_tip {
		    font-size: 14px;
		    line-height: 20px;
		    color: rgba(255, 255, 255, 0.8);
		    text-align: left;
		    margin: 3px auto 0 auto;
			margin-left: 15%;
		}
	}
	.user_top{
		width: 96%;
		position: relative;
		background: #FFFFFF;
		left: 2%;
		border-radius: 5px;
		padding: 15px 0;
		padding-bottom: 5px;
		.user_detail{
			display: flex;
			justify-content: space-between;
			text-align: center;
			.user_header {
				width: 70px;
				height: 70px;
				overflow: hidden;
				border-radius: 50%;
				position: absolute;
				top: -35px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			span{
				margin-left: 80px;
				font-size: 16px;
				font-weight: bold;
			}
		}
		.user_balance{
			text-align: center;
			p:nth-child(1){
				font-size: 14px;
			}
			p:nth-child(2){
				margin-top: 10px;
				font-weight: bold;
				font-size: 18px;
				color: #FF0000;
			}
		}
		.user_team{
			display: flex;
			justify-content: space-between;
			text-align: center;
			p{
				width: 50%;
				margin-top: 20px;
				font-size: 14px;
			}
			p:nth-child(1){
				border-right: 1px #999 solid;
			}
			span{
				color: #FF0000;
				font-weight: bold;
			}
			
		}
		.user_share{
			display: flex;
			justify-content: space-between;
			margin: 20px 0 0px 0;
			font-size: 14px;
			p:nth-child(1){
				width: 70%;
				margin-left: 20px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
				line-height: 28px;
			}
			p:nth-child(2){
				text-align: center;
				width: 20%;
				background: #e7544d;
				color: #FFFFFF;
				padding: 6px 0px;
				border-radius: 5px;
				margin-right: 15px;
			}
		}
	}
	.tabs{
		display: flex;
		justify-content: space-between;
		text-align: center;
		margin-top: -70px;
		width: 88%;
		margin-left: 6%;
		p{
			width: 28%;
			padding: 5px;
			border-radius: 5px;
		}
		.active{
			background: #f61a44;
			color: #FFFFFF;
		}
	}
	.list{
		margin-top: 10px;
		width: 96%;
		margin-left: 2%;
		background: #FFFFFF;
		border-radius: 5px;
		.item {
		    height: 52px;
		    line-height: 52px;
		    width: 314px;
		    margin: 0 auto;
		    display: flex;
		    justify-content: flex-start;
		    align-items: center;
		    border-bottom: 1px solid #E3E4E5;
			p:nth-child(1){
		        font-size: 13px;
		        color: #000;
		        margin-left: 8px;
		    }
			p:nth-child(2){
		        flex: 1;
		        margin-left: auto;
		        text-align: right;
		        font-size: 12px;
		        color: rgba(0, 0, 0, 0.4);
		    }
		}
	}
	.mask {
	    position: fixed;
	    top: 0;
	    right: 0;
	    left: 0;
	    bottom: 0;
	    background-color: rgba(0, 0, 0, 0.6);
	    z-index: 30;
	
	    .share_inner {
	        width: 230px;
			height: 280px;
	        position: absolute;
	        top: 60%;
	        left: 0;
	        right: 0;
	        margin: -232px auto 0 auto;
	        background: url(../images/user/share_bg.png) no-repeat center center;
	        background-size: 100% 100%;
			.earn{
				font-size: 32px;
				position: absolute;
				top: 112px;
				color: #fff;
				font-weight: bold;
				width: 100%;
				text-align: center;
			}
			.invite{
				font-size: 20px;
				position: absolute;
				top: 158px;
				color: #fff;
				width: 100%;
				text-align: center;
			}
			
	    }
	
	    .white_bg {
	        width: 160px;
			height: 160px;
	        background-color: #FFFFFF;
	        position: absolute;
	        top: 30px;
			left: 35px;
	        display: flex;
	        justify-content: center;
	        align-items: center;
	
	        img {
	            width: 143px;
	            height: 143px;
	        }
	    }
	
	    .basic_btn {
	        position: absolute;
	        left: 0;
	        right: 0;
	        margin: 0 auto;
	        top: 175px;
			height: 40px;
			line-height: 40px;
			font-size: 12px;
			width: 90%;
	    }
	}
	.nopermit{
		text-align: center;
		font-size: 12px;
		line-height: 25px;
		margin: 15px;
		p{
			display: flex;
			a{
				text-decoration: none;
				width: 50%;
				text-align: center;
				.basic_btn{
					width: 70%;
					margin: 0 auto;
					height: 35px;
					font-size: 12px;
					line-height: 35px;
				}
			}
		}
	}
	
	
	.scrollBox {
		width: 96%;
		margin-left: 2%;
		position: relative;
	}
	.head-tabs {
	    height: 50px;
	    padding: 15px;
	    background: #000;
	    white-space: nowrap;
		border-radius: 10px;
		margin: 10px;
		.tab-item {
		    z-index: 0;
		    position: relative;
		    height: 16px;
		    line-height: 16px;
		    font-size: 14px;
		    color: #ebedf0;
		    transition: all .3s ease;
		}
		.tab-item:after {
		    z-index: -1;
		    content: "";
		    position: absolute;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    height: 4px;
		    border-radius: 2px;
			
		}
		.active {
		    font-size: 1.5em;
		    color: #282828;
			:after {
			    background: #ff8c46;
			}
		}
		.tab-item.active:after {
		    background: #ff8c46;
		}
		.tab-item+.tab-item {
		    margin-left: 20px;
		}
	}
	.table-wrap {
	    position: relative;
	    overflow: hidden;
		margin: 10px;
		border-radius: 10px;
		padding-bottom: 70px;
	}
	.ui-table {
	    margin-bottom: -1px;
	    background: #fff7f1;
	}
	.ui-table {
	    background: #fff;
	    font-size: 12px;
	}
	.ui-table {
	    width: 100%;
	    border-collapse: collapse;
	    border-spacing: 0;
	    text-align: center;
		th {
		    height: 40px;
		    background: #ffeee2;
		    font-size: 14px;
		    color: #6c3b23;
		    text-align: center;
			font-weight: 400;
		}
		 .pl {
		    padding-left: 15px;
		}
		td {
		    height: 40px;
		    color: #6d6d6d;
		    border-bottom: 1px solid #ffe8de;
		    text-align: center;
		}
	}
	.vip-item {
	   
	    padding: 12px 16px;
	    box-sizing: border-box;
	    border-radius: 8px;
	    background-color: #fff;
	    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	    margin-bottom: 12px;
	    position: relative;
	    overflow: hidden;
	}
	.vip-item p {
		line-height: 30px;
		font-size: 13px;
		color: #666;
	}
	.vip-item .viphead {
		
		margin: 10px;
	}
	.vip-item .vip-img {
	    width: 50px;
	    height: 50px;
	}
	.vip-item .vip-info {
	    text-align: left;
		width: 100%;
		display: flex;
	}
	.vip-item .vip-info .vip-name {
	    font-size: 16px;
	    font-weight: 700;
	    color: #222;
	    margin-bottom: 12px;
	}
	.vip-item .vip-info .vip-desc {
		font-size: 14px;
		color: #f1bb0e;
		font-weight: bold;
	}
	
	.vip-item .action-box {
	    padding: 6px 16px 4px 16px;
	    text-align: center;
	    font-size: 14px;
	    color:#fff;
	    border-radius: 40px;
	    cursor: pointer;
		width: 50px;
		right: 0px;
		position: absolute;
	}
	
	.vip-item .absoulte-level {
	    position: absolute;
	    background: #f5f5f5;
	    color: #ff5001;
	    padding: 24px 16px 8px 16px;
	    border-radius: 50%;
	    top: -20px;
	    left: 50%;
	    font-size: 12px;
	}
	.vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	.vip-item .mask {
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    background: rgba(0,0,0,.4);
	    border-radius: 8px;
	    z-index: 2;
	}
	
	.vip-item .mask .lock-box,.index-wrap2 .vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	
	.vip-item .mask .lock-box {
	    background: hsla(0,0%,100%,.4);
	    width: 50px;
	    height: 50px;
	    border-radius: 50%;
	}
	.vip-item .mask .lock-box, .index-wrap2 .vip-item .mask{
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
	}
	.cards{
		padding: 16px;
		margin: 16px;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		color: #FFF;
		line-height: 20px;
		background: linear-gradient(180deg, #000 0%, #000 100%);
		.flex-e-s {
		    display: flex;
		    justify-content: space-between;
		    align-items: flex-end;
		}
		.top {
		    margin-bottom: 8px;
		}
		
		.top div {
		    font-weight: 700;
			font-size: 15px;
			line-height: 25px;
		}
		
		.top .top-left>div:last-child {
		    word-break: break-all;
		    font-style: italic;
		    font-size:26px;
			    
		}
		.flex-b-c {
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		}
		.top .top-left>div:last-child span {
		    font-style: normal;
		    font-size: 12px;
			font-weight: 400;
		}
		
		.top .top-right {
		    text-align: center
		}
		
		.top .top-right .group {
		    background-color: var(--84e63418);
		    color: var(--78b8770c);
		    padding: 2px 5px;
		    font-size: 12px;
		    flex-shrink: 0
		}
		
		.top .top-right .group img {
		    margin-right:4px
		}
		
		.top .top-right>div:first-child {
		    margin-bottom: 8px
		}
		
		.top .top-right div {
		    background-color: #fff;
		    padding: 2px 8px;
		    color: #000;
		    border-radius: 8px
		}
		
		.middle {
		    display: flex;
		    align-items: center
		}
		
		.middle span:first-child {
		    margin-right: 10px;
		}
		
		.middle span {
		    display: inline-block;
		    font-size: 12px;
		    padding: 2px 5px;
		    text-align: center;
		    color: #FFF;
		    border: 1px solid #FFF;
		    border-radius: 4px;
			line-height: 20px;
		}
		
		.mActive {
		    background-color: #F1BB0E;
		    color: #000!important;
		    border: none!important
		}
		
		.bottom {
		    margin-top: 8px
		}
		
		.bottom .bottom-left .left-item:not(:last-child) {
		    border-right: 1px solid #F1BB0E
		}
		
		.bottom .bottom-left .left-item:last-child {
		    margin-right: 0
		}
		
		.bottom .bottom-left .left-item {
		    display: flex;
		    flex-direction: column;
		    align-items: start;
		    justify-content: center;
		    margin-right: 10px;
		    padding-right: 10px;
		    font-size: 16px
		}
		
		.bottom .bottom-left .left-item div {
		    color: var(--40ca1237)
		}
		
		.bottom .bottom-left .left-item div:first-child {
		    opacity: .8;
		    font-size: 12px
		}
		
		.bottom .bottom-left .left-item div:last-child {
		    font-weight: 600;
		    word-break: break-all
		}
	}
	.con {
	    width: 100%;
		background-color: #000;
		margin-top: 15px;
		.charts {
		    padding: 16px 16px 0;
		    box-sizing: border-box;
		}
		
		.charts .charts-left {
		    min-height: 170px;
		    display: flex;
		    flex-direction: column;
		    align-items: center;
		    justify-content: space-between;
		    box-sizing: border-box
		}
		
		.charts .charts-left .left-top,.charts .charts-left .left-bottom {
		    position: relative;
		    min-width: 135px;
		    max-width: 135px;
		    box-sizing: border-box;
		    border: 1px solid #F1BB0E;
		    border-radius: 12px;
		    padding: 9px 8px
		}
		
		.charts .charts-left .left-top .char1,.charts .charts-left .left-bottom .char1 {
		    position: absolute;
		    right: 16px;
		    bottom: 8px;
		    height: 100%
		}
		
		.charts .charts-left .left-top div:nth-child(1),.charts .charts-left .left-bottom div:nth-child(1) {
		    font-size: 12px;
			line-height: 19px;
		}
		
		.charts .charts-left .left-top div:nth-child(2),.charts .charts-left .left-bottom div:nth-child(2) {
		    margin-top: -4px;
		    font-size: 20px;
		    font-weight: 700;
			line-height: 32px;
		}
		
		.charts .charts-left .left-top div:nth-child(3),.charts .charts-left .left-bottom div:nth-child(3) {
		    margin-top: -4px;
		    font-size: 10px;
			line-height: 19px;
		}
		
		.charts .charts-left .left-bottom img {
		    position: absolute;
		    right: 0;
		    z-index: 99;
		    width: 37px;
		    height: 16px;
		    top: 50px;
		    left: 60px
		}
		
		.charts .charts-left .left-bottom div:nth-child(3) {
		    background-color: #000;
		    color: #fff;
		    padding: 0 3px;
		    width: max-content;
		    text-align: center;
		    border-radius: 4px
		}
		
		.charts .charts-right1 {
		    margin: 0 6px
		}
		
		.charts .charts-right2 div:nth-child(3) {
		    background-color: #000;
		    color: #fff;
		    padding: 0 3px;
		    width: max-content;
		    text-align: center;
		    border-radius: 4px
		}
		
		.charts .charts-right1,.charts .charts-right2 {
		    flex: 1;
		    position: relative;
		    box-sizing: border-box;
		    min-width: 96px;
		    max-width:112px;
		    min-height: 170px;
		    border: 1px solid #F1BB0E;
		    padding: 6px 6px 0;
		    border-radius: 12px;
		    overflow: hidden
		}
		
		.charts .charts-right1 div:nth-child(1),.charts .charts-right2 div:nth-child(1) {
		    font-size: 12px;
			line-height: 19px;
		}
		
		.charts .charts-right1 div:nth-child(2),.charts .charts-right2 div:nth-child(2) {
		    font-size: 20px;
		    font-weight: 700;
			line-height: 32px;
		}
		
		.charts .charts-right1 div:nth-child(3),.charts .charts-right2 div:nth-child(3) {
		    font-size: 10px;
			line-height: 19px;
			word-break: auto-phrase;
		}
		
		.charts .charts-right1 .char,.charts .charts-right2 .char {
		    position: absolute;
		    bottom: 0;
		    left: -1px;
		    border-radius: 12px;
		    overflow: hidden
		}
		
		.charts .charts-right1 img,.charts .charts-right2 img {
		    width: 100%;
		    position: absolute;
		    left: 0;
		    bottom: 0
		}
		
		.vip-box {
		    width: 100%;
		    padding: 0 16px;
		    box-sizing: border-box
		}
		
		.vip-box .header2 {
		    padding: 12px 0;
		    width: 100%;
			margin-top: 10px;
		}
		
		.vip-box .header2 .label {
		    font-weight: 700;
			font-size: 15px;
		    color: #000;
		}
		
		.vip-box .header2 .more {
		    width: 65%
		}
		
		.vip-box .header2 .more .text {
		    font-weight: 700
		}
		
		.vip-box .header2 .more .img {
		    width: 14px;
		    height:14px;
		    margin-left: 3px
		}
		
		.vip-box .svip {
		    background: #F1BB0E;
		    border-radius: 4px;
		    padding: 0 8px;
		    height: 65px;
		    color: #000;
		}
		
		.vip-box .svip span,.vip-box .svip i {
		    font-weight: 700;
		    margin-left: 8px
		}
		
		.vip-box .svip img {
		    width: 36px;
		    height: 36px
		}
		
		.notice-swipe {
		    height: 28px
		}
		
		.notice-swipe .notice-swipe-item {
		    height: 28px;
		    line-height: 28px
		}
		.VipLevel {
		    width: 100%;
		    height:50px;
		    background: #F1BB0E;
		    border-radius: 8px;
		    padding: 0 10px;
		    color: #000
		}
		
		.VipLevel .left .level {
		    font-size: 16px;
		    font-weight: 700;
		    margin-left:10px
		}
		
		.VipLevel .right .clickToEnte {
		    font-size: 14px;
		    font-weight: 700
		}
		.flex-b-s {
		    display: flex;
		    justify-content: space-between;
		    align-items: flex-start;
		}
		
		.flex-b-c {
		    display: flex;
		    justify-content: space-between;
		    align-items: center
		}
	}
	.top_header {
		position: relative;
		width: 100%;
		background-size: 100% 100%;
		// background: #f1bb0e;
		.set_go{
			width: 38px;
			height: 38px;
			position: absolute;
			top: 11px;
		}
		
		.set_go {
			right: 14px;
			background: url(../images/user/sign.png) no-repeat center center;
			background-size: 100% 100%;
		}
		.user_detail {
			width: 100%;
			padding: 15px 15px 0 15px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			.user_header {
				width: 60px;
				height: 60px;
				overflow: hidden;
				border-radius: 50%;
				border: 1px solid rgba(255, 255, 255, 0.3);
				img {
					width: 100%;
					height: 100%;
				}
			}
			.user_name {
				margin-left: 3px;
				margin-top: 3px;
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				color: #fff;
				.user_all {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					.user_nickname {
						line-height: 1.6em;
						font-size: 1.2em;
						margin-left: 1em;
					}
				}
			}
		}
		.user_vip{
			color: #FFFFFF;
			font-weight: bold;
			font-size: 16px;
			margin: 10px 20px 20px 20px;
		}
		.user_balance{
			text-align: center;
			div{
				margin: 10px 0;
			}
			div:nth-child(1){
				font-size: 14px;
				color: #d3d5d6;
			}
			div:nth-child(2){
				font-weight: bold;
				font-size: 18px;
				color: #FFFFFF;
			}
		}
		.user_money{
			justify-content: space-between;
			text-align: center;
			
		}
	}
	
	
	
	.vipContent {
	    position: relative;
	    margin-top: 30px;
		padding-bottom: 80px;
		background: #000;
		.vipss {
		    display: flex;
		    flex-direction: column;
		    justify-content: center;
		    align-items: center;
		    margin-right: 0
		}
		
		.BG {
		    width: 100%;
		    position: absolute;
		    top: 32px;
		}
		
		.BG2 {
		    width: 100%;
		    position: absolute;
		    top: 64px;
		}
		
		.vip {
		    z-index: 99;
		    position: relative;
		    margin: auto;
		    border-radius: 20px;
		    border: 2px solid rgba(255,255,255,.24);
		    background: linear-gradient(102deg,rgba(255,255,255,.23) 15.9%,rgba(255,255,255,.11) 105.94%);
		    height: 188px;
		    display: flex;
		    flex-direction: column
		}
		
		.vip .Viplevel {
		    width: 80%;
		    padding: 16px 0;
		    margin: auto
		}
		
		.vip .Viplevel .left .vipText {
		    color: #fff;
		    margin-left: 17px;
		    font-size: 14px;
			font-weight: bold;
		}
		.flex-b-c {
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		}
		.vip .Viplevel .right .haveOpened {
		    padding: 5px 8px;
		    background: url(../images/shop/haveOpened.png) no-repeat center;
		    text-align: center;
		    color: #F1BB0E;
		    font-weight: 700;
		    background-size: 100% 100%;
		    width: max-content;
			line-height: 25px;
			font-size: 15px;
		}
		
		.vip .progressBar {
		    width: 80%;
		    margin: auto;
		    height: 24px;
		    position: relative
		}
		
		.vip .progressBar .dot {
		    width: 16px;
		    height: 16px;
		    background-color: #fff;
		    border-radius: 50%;
		    position: absolute
		}
		
		.vip .exp {
		    width: 80%;
		    margin: auto;
		    font-family: Inter;
		    color: #fff;
		    font-size: 19px;
		}
		.flex-s-c {
		    display: flex;
		    justify-content: flex-start;
		    align-items: center;
		}
		.flex-b-s {
		    display: flex;
		    justify-content: space-between;
		    align-items: flex-start;
		}
		.vip .CurrentVIPlevel {
		    width: 99.5%;
		    margin: 0;
		    text-align: center;
		    font-size: 20px;
		    letter-spacing: 2.73px;
		    color: #fff;
		    border-radius: 0 0 20px 20px;
		    border: 2px solid rgba(255,255,255,.24);
		    box-shadow: 0 0 34px #553c8f40;
		    -webkit-backdrop-filter: blur(15px);
		    backdrop-filter: blur(15px);
		    padding: 7px 0
		}
		.Tips{
		    width: 80%;
		    color: #fff;
		    margin: 0 auto;
		    margin-top: 48px;
		    position: relative;
		    z-index: 99;
		    min-height: 200px;
		    max-height: 200px;
		    overflow: hidden;
		    overflow-y: auto;
			line-height: 25px;
			font-size: 14px;
		}
		.dredge{
		    width: 100%;
		    margin: 32px auto auto;
		    padding-bottom: 32px;
			.Btn{
				background-color: #F1BB0E;
				color: #000;
				border: none;
			}
		}
	}
	/deep/ .van-swipe__indicators{
		top: 200px;
	}
	.basic_wrap{
		background-color: #000;
		height: 100vh;
	}
</style>
